export default __webpack_public_path__ + "static/media/9.fcc221f2.jpg";